import script from "./FooterBar.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterBar.vue?vue&type=script&setup=true&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=563aae24&scoped=true&lang=css"

import exportComponent from "../../../author/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563aae24"]])

export default __exports__